import React, {Component, Children} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import * as tradeBookActions from './../../actions/tradeBookActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as activityActions from './../../actions/activityActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as reportActions from './../../actions/reportActions';
import * as authActions from '../../redux/modules/auth';
import * as commonActions from './../../actions/commonActions';
import PhysicalsAllocation from './PhysicalsAllocation';
import styles from './../TradeBook/TradeBook.less';
import config from './../../config';
import Modal from 'react-modal';
import {ButtonToolbar,  DropdownButton,  MenuItem,  Tabs,  Tab,  Button,  Checkbox} from 'react-bootstrap';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
import numeral  from 'numeral';
import { applyStyle,getCountofTableRows,applyToHoverapplyClickActive,getSeparator,setDirection,unformatLang} from './../../utils/utils';
// const elementsData = [
//   {"classNames":"header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"OpntrdModifyWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
// 	{"classNames":"form-control","elementType":"tag", "applyTo":"all", "tagNames":"input"},
//   {"classNames":"oi-eye","elementType":"tag", "applyTo":"all", "tagNames":"span"},
//   {"classNames":"noDataColor", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"widgetwrapper", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"dx-g-bs4-table-container","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"dx-g-bs4-table-cell","elementType":"normal", "applyTo":"all", "tagNames":"td"},
//   {"classNames":"card", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"reportsTblTh", "elementType":"tag", "applyTo":"all", "tagNames":"th"},
//   {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"lmtClose","elementType":"normal", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"}
// ];
const directionData=[
  {"classNames":"header","elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"errorheader","elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"commentDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"nav-tabs","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"reportsTbl", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"btnWrapDiv", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"qtydiv", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"allocationinfo", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"opnTrdTblTd", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdbookText","elementType":"normal", "applyTo":"all", "tagNames":"span"}
];
const getRowId = row => row.docNo;
import i18next from 'i18next';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
let compareRate = (a, b) => {
  let result;
    if (numeral(a)._value < numeral(b)._value) {
      result = -1;
    }else{
      result = 1;
    }
    return result;
};
let separator;
let decimal;
let decimalCount = 1;

@connect(state => ({
  opnTrdModifyFlag:state.dashboardRoot.tradeBookReducer.opnTrdModifyFlag,
  closeOpnTrdModifypopup:state.dashboardRoot.tradeBookReducer.closeOpnTrdModifypopup,
  ordersCTID:state.dashboardRoot.activityReducer.ordersCTID,
  userDetail: state.auth.userDetail,
  status: state.dashboardRoot.instrumentListReducer.status,
  socketData: state.dashboardRoot.instrumentListReducer.socketData,
  tradeBookColumns: state.dashboardRoot.dashboardReducer.tradeBookColumns,
  language:state.dashboardRoot.commonReducer.language,
  selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  fontSize: state.auth.userDetail.fontSize,
  navigationStatus: state.dashboardRoot.commonReducer.navigationStatus,
  opentradeBook:state.dashboardRoot.instrumentListReducer.opentradeBook,
  openTradeLoaderFlag:state.dashboardRoot.instrumentListReducer.openTradeLoaderFlag,
  openTrdRandomNoDB:state.dashboardRoot.instrumentListReducer.openTrdRandomNoDB,
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  configInfo:state.auth.configInfo,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
}), {
...reportActions,...tradeBookActions,...dashboardActions,...activityActions,...tradepanelActions,...authActions, ...commonActions
})
export default class OpenTradeAllocateComponent extends Component {
  static propTypes = {
    userDetail: PropTypes.object,
    opnTrdModifyFlag:PropTypes.bool,
    ordersCTID:  PropTypes.array,
    openTrdRefreshFlag:PropTypes.func,
    updateTrdBookCols:PropTypes.func,
    layoutChanged:PropTypes.func,
    tradeBookColumns: PropTypes.array,
    language:PropTypes.string,
    navigationStatus: PropTypes.string,
    getInvoice: PropTypes.func,
    opentradeBook:PropTypes.object,
    getOpenTrdes: PropTypes.func,
    allocateQuantity: PropTypes.func,
  };
  state = {
    allocationRecords:[],
    selectedRowDocNo: '',
    key:1,
    allocationQuantity:'',
    docList:[],
    availableQuantity:0,
    selectedAvailableQty:0,
    totalQtyPending:0,
    maxQuantityExceed:false,
    selectAllocQtyModal:false,
    zeroQuantity:false
  }
constructor() {
   super();
   //coloumnSelection
   this.afterOpenModal = this.afterOpenModal.bind(this);
}
componentWillMount(){

}
componentDidMount() {
  const thisComponent = ReactDOM.findDOMNode(this);
  //const allCssStyleRules = this.props.selectedCssColorTheme;
  //applyStyle(thisComponent, allCssStyleRules, elementsData);
  setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
  // applyClickActive(thisComponent.getElementsByTagName("li"), allCssStyleRules);
  const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
      {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[0], "classNames":"lmtClose"},
      {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[1], "classNames":"lmtClose"}
      //{"elmToHover":thisComponent.getElementsByClassName('dropDownList')[0], "classNames":"dropDownList"}
  ];
  //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  this.setState({allocationRecords: this.props.allocateRow});
  this.setState({availableQuantity: this.props.fetchAvailableQty[0].gq});
  this.setState({selectedAvailableQty: Number(parseFloat(0)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
  this.setState({totalQtyPending: this.props.fetchAvailableQty[0].gq});
  //Get separator based on locale
  separator = getSeparator(navigator.language,'group');
  //Get group based on locale
  decimal = getSeparator(navigator.language,'decimal');
}
// componentDidUpdate(preProps){
//   const thisComponent = ReactDOM.findDOMNode(this);
//   //const allCssStyleRules = this.props.selectedCssColorTheme;
//   applyStyle(thisComponent, allCssStyleRules, elementsData);
//  }
componentWillReceiveProps(nextProps){
  // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
  //   const thisComponent = ReactDOM.findDOMNode(this);
  //   const allCssStyleRules = nextProps.selectedCssColorTheme;
  //   //applyStyle(thisComponent, allCssStyleRules, elementsData);
  //   applyClickActive(thisComponent.getElementsByTagName("li"), allCssStyleRules);
  // }
}
handleSelect = (key) =>{
  try{
    this.setState({key:key});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'handleSelect', component:"OpenTradeAllocateComponent"});
  }
}
clearAllocation= (event) => {
  try{
    // this.refs.comments.value="";
    this.props.closeOpnTrdAllctMdl(false);
    this.state.allocationRecords.map((item, index) => {
        item.selectedQty=parseFloat(0).toFixed(3);
    })
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'clearAllocation', component:"OpenTradeAllocateComponent"});
  }
}
cancelmaxQuantityModal = (event) => {
  try{
    this.setState({maxQuantityExceed:false});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'cancelmaxQuantityModal', component:"OpenTradeAllocateComponent"});
  }
}
cancelAllocQtyModal = (event) => {
  try{
    this.setState({selectAllocQtyModal:false});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'cancelAllocQtyModal', component:"OpenTradeAllocateComponent"});
  }
}
cancelZeroQuantityModal = (event) => {
  try{
    this.setState({zeroQuantity:false});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'cancelZeroQuantityModal', component:"OpenTradeAllocateComponent"});
  }
}
checkNumberValue =(event) =>{
  try{
    if (String.fromCharCode(event.which) != separator && event.which > 31 && (event.which < 48 || event.which > 57) && (String.fromCharCode(event.which)!==separator) && (String.fromCharCode(event.which)!==decimal)){
       event.preventDefault();
     }
    if(event.target.value.indexOf(decimal)===-1){
      decimalCount = 0;
    }
    // if(event.which === separator.charCodeAt(0) || (event.which === decimal.charCodeAt(0) && decimalCount>=1)){
    //     event.preventDefault();
    // }
    if(event.which === decimal.charCodeAt(0)||event.target.value.indexOf(decimal)!==-1){
      decimalCount+=1;
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'checkNumberValue', component:"OpenTradeAllocateComponent"});
  }
  }
isDisable = (docNo) => {
  try{
    var flag=0;
    for(let i=0;i<this.state.docList.length;i++){
      if(docNo===this.state.docList[i]){
        return false;
        flag=1;
      }
    }
    if(flag===0){
      return true;
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'isDisable', component:"OpenTradeAllocateComponent"});
  }
}
submitAllocateQty = () =>{
  try{
    var flag1=0;
    var flag2=0;
    if(this.state.docList.length===0){
      flag1=1;
    }
    for(var i=0;i<this.state.docList.length;i++){
      this.state.allocationRecords.map((item, index) => {
        if(this.state.docList[i]===item.docNo){
          let itemQty = unformatLang((item.selectedQty).toString());// replaced regional decimal separator into en-US
          itemQty = Number(parseFloat(itemQty)); //convert itenm selected qty to Number
          if(itemQty === 0){
            flag2=1;
          }
        }
      })
    }
    if(flag1==1){
      this.setState({selectAllocQtyModal:true});
    }else if(flag2==1){
      this.setState({zeroQuantity:true});
    }else{
      var linkDocData=[];
      var tempcArr=JSON.parse(localStorage.getItem('convFactor'));
      var convFactor = new Map(tempcArr.map(i => [i.key, i.val]));
      this.state.allocationRecords.map((item, index) => {
        let itemQty = unformatLang((item.selectedQty).toString()) // replaced regional decimal separator into en-US
        itemQty = Number(parseFloat(itemQty)); //convert itenm selected qty to Number
        if( itemQty !== 0){
          var obj = {
            'ToDN':item.docNo,
            // 'DT':item.deal==="BUY"?1:0,
            // 'IID':item.iid,
            // 'SC':item.qtyType,
            // 'PQ':item.selectedQty/convFactor.get(item.qtyType),
            'GQ':unformatLang((item.selectedQty)),
            'ToDocSN':item.DocSrNo
          }
          linkDocData.push(obj);
        }
      })
      var dealType=0;
      if(this.props.fetchAvailableQty[0].deal==="BUY"){
        dealType=0;
      }else{
        dealType=1;
      }
      var location=window.location.hostname==="localhost"?config.location:this.props.configInfo.location;
      this.props.allocateQuantity("F",JSON.parse(localStorage.getItem("DFA")).C,location,this.props.fetchAvailableQty[0].docNo,dealType,this.props.fetchAvailableQty[0].DocSrNo,JSON.parse(localStorage.getItem('user')).UID,linkDocData);
      this.props.closeOpnTrdAllctMdl(false);
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'submitAllocateQty', component:"OpenTradeAllocateComponent"});
  }
}
handleAllocateOnclick = (event,docNo) => {
  try{
    this.setState({allocationQuantity: event.target.value});
    this.setState({selectedRowDocNo:docNo});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'handleAllocateOnclick', component:"OpenTradeAllocateComponent"});
  }
}
handleAllocateBlur = (event,docNo) => {
  try{
    var formatQty=Number(parseFloat(unformatLang(event.target.value))).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
    // event.target.value=parseFloat(event.target.value).toFixed(3);
    if(event.target.value === ""){
      this.setState({allocationQuantity: ""});
      this.setState({selectedRowDocNo:docNo});
    }
    else{
    this.setState({allocationQuantity:formatQty});
    this.setState({selectedRowDocNo:docNo});
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'handleAllocateBlur', component:"OpenTradeAllocateComponent"});
  }
}

handleAllocateInput = (event,docNo,qty) => {
  try{
    var value=event.target.value===''?0:unformatLang(event.target.value);
    this.setState({selectedRowDocNo:docNo});
    var totalQty=Number(parseFloat(value)); //converted totalQty into Number
    var totalSQtyWithoutVal=0;
    qty=unformatLang(qty);
    var totalQtyPending=unformatLang(this.state.totalQtyPending);
    var selectedAvailableQty=unformatLang(this.state.selectedAvailableQty);
    var availableQuantity=unformatLang(this.state.availableQuantity);
    this.state.allocationRecords.map((item, index) => {
      if(item.docNo!==docNo){
        var test=unformatLang((item.selectedQty).toString());
        totalQty=totalQty+Number(parseFloat(test)); // converted item.selectedQty into orignal number format to calculate totalQty
        totalSQtyWithoutVal=totalSQtyWithoutVal+Number(parseFloat(test)); // converted item.selectedQty into orignal number format to calculate totalSQtyWithoutVal
      }
    })
    if(parseFloat(totalQty)>parseFloat(availableQuantity) || parseFloat(value)>parseFloat(qty)){
      this.setState({maxQuantityExceed:true});
      this.state.allocationRecords.map((item, index) => {
        if(item.docNo===docNo){
          var totalPQtyWithoutVal=parseFloat(availableQuantity)-parseFloat(totalSQtyWithoutVal);
          var allocationQuantity=0;
          if(totalPQtyWithoutVal<parseFloat(qty)){
            this.setState({allocationQuantity: Number(parseFloat(totalPQtyWithoutVal)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
            allocationQuantity=parseFloat(totalPQtyWithoutVal).toFixed(3);
          }else{
            this.setState({allocationQuantity: Number(parseFloat(qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
            allocationQuantity=parseFloat(qty);
          }
          this.state.allocationRecords.map((item, index) => {
            if(item.docNo===docNo){
              item.selectedQty=Number(parseFloat(allocationQuantity)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
            }
          })
          var selectedAvailable=parseFloat(totalSQtyWithoutVal)+parseFloat(allocationQuantity);
          this.setState({selectedAvailableQty:Number(parseFloat(selectedAvailable)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
          var totalQtyPending=parseFloat(availableQuantity)-(parseFloat(totalSQtyWithoutVal)+parseFloat(allocationQuantity));
          this.setState({totalQtyPending: Number(parseFloat(totalQtyPending)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
        }
      })
    }else{
      this.state.allocationRecords.map((item, index) => {
        if(item.docNo===docNo){
          item.selectedQty=Number(parseFloat(value)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
        }
      })
      var quantity=0;
      this.state.allocationRecords.map((item, index) => {
        var test1=unformatLang((item.selectedQty).toString());
        quantity=quantity+Number(parseFloat(test1)); // converted item.selectedQty into orignal number format to calculate quantity
      })
      this.setState({allocationQuantity: (event.target.value).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })}); // added langauge Number formatter
      this.setState({selectedAvailableQty: Number(parseFloat(quantity)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
      var totalQtyPending=parseFloat(availableQuantity)-parseFloat(quantity);
      this.setState({totalQtyPending: Number(parseFloat(totalQtyPending)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'handleAllocateInput', component:"OpenTradeAllocateComponent"});
  }
}
handleChangeInput= (event,docNo,qty) => {
  try{
    this.setState({selectedRowDocNo:docNo});
    qty=unformatLang(qty);
    var totalQtyPending=unformatLang(this.state.totalQtyPending);
    var selectedAvailableQty=unformatLang(this.state.selectedAvailableQty);
    var availableQuantity=unformatLang(this.state.availableQuantity);
    if(event.target.checked){
      if(parseFloat(totalQtyPending)===0){
        this.setState({maxQuantityExceed:true});
        this.setState({allocationQuantity: ''});
        event.target.checked=!event.target.checked;
      }else{
      if(parseFloat(totalQtyPending)<parseFloat(qty)){
        this.setState({allocationQuantity: Number(parseFloat(totalQtyPending)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
        var quantity=parseFloat(selectedAvailableQty)+parseFloat(totalQtyPending);
        this.setState({selectedAvailableQty: Number(parseFloat(quantity)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
        var totalPending=parseFloat(availableQuantity)-parseFloat(quantity);
        this.setState({totalQtyPending: Number(parseFloat(totalPending)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
        this.state.allocationRecords.map((item, index) => {
          if(item.docNo===docNo){
            item.selectedQty=Number(parseFloat(totalQtyPending)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
          }
        })
      }else{
        this.setState({allocationQuantity: Number(parseFloat(qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
        var quantity=parseFloat(selectedAvailableQty)+parseFloat(qty);
        this.setState({selectedAvailableQty: Number(parseFloat(quantity)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
        var totalPending=parseFloat(availableQuantity)-parseFloat(quantity);
        this.setState({totalQtyPending: Number(parseFloat(totalPending)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
        this.state.allocationRecords.map((item, index) => {
          if(item.docNo===docNo){
            item.selectedQty=Number(parseFloat(qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
          }
        })
      }
      var doc=[];
      doc.push(docNo);
      this.setState({docList:this.state.docList.concat(doc)});
      }
    }else{
      var selectedQty=0;
      // if(parseFloat(totalQtyPending)<parseFloat(qty.replace(/\,/g,''))){
        this.state.allocationRecords.map((item, index) => {
          if(item.docNo===docNo){
            var testQty=unformatLang((item.selectedQty).toString());
            selectedQty=selectedQty+Number(parseFloat(testQty));// converted item.selectedQty into orignal number format to calculate selectedQty
            item.selectedQty=Number(parseFloat(0)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
          }
        })
        this.setState({allocationQuantity: ''});
        var quantity=parseFloat(selectedAvailableQty)-parseFloat(selectedQty);
        this.setState({selectedAvailableQty: Number(parseFloat(quantity)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
        var totalPending=parseFloat(availableQuantity)-parseFloat(quantity);
        this.setState({totalQtyPending: Number(parseFloat(Math.abs(totalPending))).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })});
      // }else{
      //   this.setState({allocationQuantity: ''});
      //   var quantity=parseFloat(selectedAvailableQty)-parseFloat(qty.replace(/\,/g,''));
      //   this.setState({selectedAvailableQty: parseFloat(quantity).toFixed(3)});
      //   var totalPending=parseFloat(this.state.availableQuantity)-parseFloat(quantity);
      //   this.setState({totalQtyPending: parseFloat(totalPending).toFixed(3)});
      //   this.state.allocationRecords.map((item, index) => {
      //     if(item.docNo===docNo){
      //       item.selectedQty=parseFloat(0).toFixed(3);
      //     }
      //   })
      // }
      for(let i=this.state.docList.length-1;i>=0;i--){
        if(docNo===this.state.docList[i]){
          this.state.docList.splice(i,1);
        }
      }
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'handleChangeInput', component:"OpenTradeAllocateComponent"});
  }
}
afterOpenModal() {
  try{
    const thisComponent = this.refs.errorMSG;
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //  const elementsData = [
    //    {"classNames":"errorheader", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
    //    {"classNames":"closeBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
    //    {"classNames":"msgWrap", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
    //    {"classNames":"mdlWrap", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
    //    {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"single", "tagNames":"button"},
    //    {"classNames":"lmtClose","elementType":"normal", "applyTo":"all", "tagNames":"button"},
    //    {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"span"},
    //  ];
    //  applyStyle(thisComponent, allCssStyleRules, elementsData);
    const directionData = [
      {"classNames":"errorheader", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"opnTrdCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"opnTrdTblTd", "elementType":"normal", "applyTo":"all", "tagNames":"div"}
    ];
    setDirection(thisComponent,directionData,this.props.selectedLang);
    applyClickActive(thisComponent.getElementsByTagName("li"), allCssStyleRules);
    const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[0], "classNames":"lmtClose"},
        {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[1], "classNames":"lmtClose"}
        //{"elmToHover":thisComponent.getElementsByClassName('dropDownList')[0], "classNames":"dropDownList"}
    ];
    //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"OpenTradeAllocateComponent"});
  }
}
render() {
const selectedfont_size ="fontSize_"+this.props.userDetail.fontSize;
const closeIcon = <MUIIconWithTooltip icon={'Close'} className={`closeBtn commonCloseIcon`} title={i18next.t("close")}/>
var OutstandingOrderHeader ='';
if(this.props.userDetail.fontSize == 'S'){
  OutstandingOrderHeader = 'tradeBookHeaderSfont';
}else if(this.props.userDetail.fontSize == 'N'){
  OutstandingOrderHeader = 'tradeBookHeaderMfont'
}else{
  OutstandingOrderHeader = 'tradeBookHeaderLfont'
}
return (
      <div className={`${styles.trdbody} ${selectedfont_size}`} id="allocationDiv">
        <div className={`${styles.header} header`}>
          <span className={`${styles.msgTitle}`}><span className="trdbookText">{i18next.t('allocate')+' '}</span><span>{this.props.fetchAvailableQty[0].docNo}</span></span>
          <span onClick={this.clearAllocation} className={`${styles.closeImg} closeIcon`} id="lmtCloseModalIcon">{closeIcon}</span>
        </div>
          <Modal isOpen={this.state.maxQuantityExceed} id="allocErrModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
           <div  ref="errorMSG" className="mdlWrap" >
             <div className={`${styles.errorheader} errorheader`}>
               <span className={`${styles.errormsgTitle}`}>{i18next.t("error")}</span>
              <span onClick={this.cancelmaxQuantityModal} className="sqrOffErrCloseIcon closeIcon opnTrdCloseIcon">{closeIcon}</span>
             </div>
             <div className={`${styles.msgWrap} msgWrap commonMsgDir`}>
               <h4>{i18next.t("allocMaxQtyMsg")+"."}</h4>
            </div>
           </div>
         </Modal>
         <Modal isOpen={this.state.zeroQuantity} id="allocWarningModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
          <div  ref="errorMSG" className="mdlWrap" >
            <div className={`${styles.errorheader} errorheader`}>
              <span className={`${styles.errormsgTitle}`}>{i18next.t("error")}</span>
              <span onClick={this.cancelZeroQuantityModal} className="sqrOffErrCloseIcon closeIcon opnTrdCloseIcon">{closeIcon}</span>
            </div>
            <div className={`${styles.msgWrap} msgWrap commonMsgDir`}>
              <h4>{i18next.t("allocZBQtyMsg")+"."}</h4>
           </div>
          </div>
        </Modal>
         <Modal isOpen={this.state.selectAllocQtyModal} id="allocErrValModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
          <div  ref="errorMSG" className="mdlWrap" >
            <div className={`${styles.errorheader} errorheader`}>
              <span className={`${styles.errormsgTitle}`}>{i18next.t("error")}</span>
              <span onClick={this.cancelAllocQtyModal} className="sqrOffErrCloseIcon closeIcon opnTrdCloseIcon">{closeIcon}</span>
            </div>
            <div className={`${styles.msgWrap} msgWrap commonMsgDir`}>
              <h4>{i18next.t("allocAtleastOneQtyMsg")+"."}</h4>
           </div>
          </div>
        </Modal>
        <Tabs activeKey={this.state.key} animation={false} id="allocation_tabs" onSelect={this.handleSelect} className={`${this.props.selectedCssColor} trdTabName`}>
          <Tab eventKey={1} title={i18next.t('fixing')}>
            <div className={`${this.props.language}`}>
              <div className={`allocationTbl ${OutstandingOrderHeader} ${selectedfont_size} widgetwrapper ` + this.props.selectedCssColor} id="outLimitTbl">
                <table id="allocationtbl" className="reportsTbl">
  								<thead>
  									<tr>
                      <th className="reportsTblTh"></th>
                      <th className="reportsTblTh">{i18next.t('docNo')}</th>
                      <th className="reportsTblTh">{i18next.t('quantity')}</th>
                      <th className="reportsTblTh">{i18next.t('price')}</th>
                      <th className="reportsTblTh">{i18next.t('allocateQty')}</th>
  									</tr>
  								</thead>
  								<tbody>
  									{this.state.allocationRecords.length>0?this.state.allocationRecords.map((item, index) => {
  										return (
  											<tr >
                          <td>
                          <label className={`${styles.containerClass} cust-box`}>
                            <input
                              type="checkbox"
                              name={item.docNo}
                              value={item.docNo}
                              className="checkbox"
                              onChange={() =>this.handleChangeInput(event,item.docNo,item.gq)}/>
                              <span className='checkmark'></span>
                          </label>    
                          </td>
                          <td style={this.props.selectedLang.opnTrdTblTd}>{item.docNo}</td>
                          <td>{item.gq}</td>
                          <td>{item.price}</td>
                          <td>
                            <input
                              className="selectedAlloc"
                              type="text"
                              disabled={this.isDisable(item.docNo)}
                              onKeyPress={this.checkNumberValue}
                              value={this.state.selectedRowDocNo===item.docNo?this.state.allocationQuantity:null}
                              min='0'
                              onChange={() =>this.handleAllocateInput(event,item.docNo,item.gq)}
                              onClick={() =>this.handleAllocateOnclick(event,item.docNo)}
                              onBlur={()=>this.handleAllocateBlur(event,item.docNo)}
                            />
                          </td>
  											</tr>
  										);
  									}):<div className={styles.noDataDiv}><p >{i18next.t("noDataAvlMsg")}</p></div>
  									}
  								</tbody>
  							</table>
              </div>
              <div className={`${styles.allocationinfo} allocationinfo`}>
                {/*<div>Total available quantity to allocate: {this.state.availableQuantity}</div>*/}
                <div className="qtydiv"><span>Allocate Quantity:</span> {this.state.selectedAvailableQty}</div>
                <div className="qtydiv"><span>Pending Quantity:</span> {this.state.totalQtyPending}</div>
              </div>
              <div className={`${styles.button_wrapAlloc} col-sm-12 btnWrapDiv`}>
                <div className={`${styles.col3}`}> &nbsp;</div>
                <div className={`${styles.submitbtn} ${styles.col3}`}>
                  <ButtonToolbar>
                    <Button className={`lmtClose ${styles.button}`}
                    onClick={() => this.submitAllocateQty()} id="lmtOrdSubmitBtn">{i18next.t("allocate")}</Button>
                  </ButtonToolbar>
                </div>
                <div className={`${styles.canceltbtn} ${styles.col3}`}>
                  <ButtonToolbar>
                    <Button className={`lmtClose ${styles.button}`} onClick={this.clearAllocation} id="clearbtn">{i18next.t("close")}</Button>
                  </ButtonToolbar>
                </div>
              </div>
            </div>
          </Tab>
          <Tab eventKey={2} title={i18next.t('physicals')}>
            <PhysicalsAllocation allocateRow={this.props.allocateRow} fetchAvailableQty={this.props.fetchAvailableQty}/>
          </Tab>
        </Tabs>
      </div>
    );
  }
}
